import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '../../../components/atoms';

const ModalImageInfo = ({
  title,
  image,
  text,
  diseasesList,
  onClose,
}) => (
  <Modal onClose={onClose} size="forDps" text="" color="#4F4FFF">
    <div className="modal- w-scroll">
      <div className="modal-alert_dps__title">
        <img src={image} alt="imagen" />
        <div className="title">
          {title}
        </div>
      </div>
      <p className="modal-alert_dps__detail">
        {text}
      </p>
      <div className="modal-alert_dps__list">
        {
          diseasesList?.map((item, i) => (
            <div key={`info-${i}`} className="list-title">
              <b>{item.title}</b>
              <ul className="list-disc">
                {
                  item.items.map((it, i) => (
                    <li key={`info-item-${i}`} className="modals__list-item">
                      {it}
                    </li>
                  ))
                }
              </ul>
            </div>
          ))
        }
      </div>
    </div>
  </Modal>
);

ModalImageInfo.defaultProps = {
  text: '',
  image: '',
  diseasesList: [],
};

ModalImageInfo.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  image: PropTypes.string,
  diseasesList: PropTypes.arrayOf(PropTypes.shape({})),
  onClose: PropTypes.func.isRequired,
};

export default ModalImageInfo;
